import React from "react"
import { Container, Row, Col } from "reactstrap"
import ExtendSession from "../CommonForBoth/TopbarDropdown/ExtendSession"

const Footer = () => {
  return (
    <React.Fragment>
      
      <footer className="footer">
        <Container fluid={true}>
        <ExtendSession/>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Flamingo</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                TekyMart
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
